import { defineComponent as _defineComponent } from 'vue'
import type { HomeModules } from '@/features/onboarded-home/types';
import type { AssertByTypename } from '@/helpers/graphql-model-helper';

import SpinnerDots from '@/features/ui/components/SpinnerDots.vue';
import ModulesLoader from '@/features/onboarded-home/components/ModulesLoader.vue';
import JWTVEndCard from '@/features/onboarded-home/components/JWTVEndCard.vue';
import { useQuery } from '@/helpers/composables/useApollo';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';

import { computed } from 'vue';
import Top10JWTVModule from '@/features/jwtv-titles-rental/components/modules/Top10JWTVModule.vue';
import {
	GetTvHomeModulesDocument,
	GetTvHomeModulesQuery,
	GetTvHomeModulesQueryVariables,
} from '@/features/jwtv-home/graphql/queries/GetTVHomeModules.query';
import { useModuleContextData } from '@/features/onboarded-home/tracking';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'JWTVLP',
  setup(__props) {

const { language, country } = storeToRefs(useLanguageStore());
const { activeDomain, activeRoute } = storeToRefs(useRoutingStore());
const { provideModulePlacement } = useModuleContextData();

provideModulePlacement(() => 'JWTV_LP');

// const enabled = computed(() => route.name === 'app.home');
const { result, loading } = useQuery<GetTvHomeModulesQuery, GetTvHomeModulesQueryVariables>(
	GetTvHomeModulesDocument,
	() => ({
		fullPath: activeRoute.value.path,
		site: activeDomain.value,
		country: country.value,
		language: language.value,
		locale: `${language.value.toLowerCase()}-${country.value.toUpperCase()}`,
		watchNowFilter: {
			packages: ['jwt'],
			withFallback: true,
		},
		includeStandaloneModules: true,
	}),
	{
		fetchPolicy: 'cache-first',
		errorPolicy: 'all',
		enabled: computed(() => activeRoute.value?.name === 'app.jwtv.landing-page'),
	}
);

const modules = computed(() => {
	const node = result.value?.urlV2.node;
	const _modules = (node as AssertByTypename<typeof node, 'HomePage'>)?.modules ?? [];

	return _modules.filter(module => module != null) as HomeModules;
});

const top10Module = computed(() => {
	return modules.value.find(module => module?.__typename === 'HMTop10InYourCountry');
});

const filteredModules = computed(() => {
	return modules.value.filter(module => module?.__typename !== 'HMTop10InYourCountry');
});

const isLoading = computed(() => loading.value || modules.value.length === 0);

return { __sfc: true,language, country, activeDomain, activeRoute, provideModulePlacement, result, loading, modules, top10Module, filteredModules, isLoading, SpinnerDots, ModulesLoader, JWTVEndCard, Top10JWTVModule }
}

})